<template>
  <el-dialog class="dialog-detail" :title="title" top="5vh" :visible.sync="visible" width="1200px">
    <div class="dialog-detail__main">
      <div class="dialog-info">
        <h3>会话信息</h3>
        <div class="info-row" v-for="(info, i) in infos" :key="i">
          <span class="label">{{ info.label }}:</span>
          <span>{{ info.value }}</span>
        </div>
      </div>
      <div class="dialogs">
        <div ref="content" class="content">
          <div class="chat-row" :class="{ isUserMsg: cm.isUserMsg }" v-for="(cm, i) in chatMessages" :key="i">
            <div class="chat-item">
              <span v-html="cm.content"></span>
              <span class="time">{{ cm.sentTime | changeDate }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination :page-sizes="[10, 20]" :current-page.sync="params.pageNumber" :page-size.sync="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" background></el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import aiFriendManageApi from '../../../../api/aiFriendManage';

export default {
  data() {
    return {
      visible: false,
      chatSession: null,
      chatMessages: [],
      id: null,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0
    };
  },
  watch: {
    id() {
      this.params.pageNumber = 1
      this.getDialogDetail()
    },
    params: {
      handler() {
        this.getDialogDetail()
      },
      deep: true
    }
  },
  computed: {
    title() {
      return '预览会话'
    },
    infos() {
      const session = this.chatSession
      if (!session) return []
      const { id, aiRoleId, appId, createdAt, startTime, userId, uniqueId } = session
      return [
        { label: '会话ID', value: id },
        { label: '角色ID', value: aiRoleId },
        { label: '应用ID', value: appId },
        { label: '用户ID', value: userId },
        { label: '用户唯一ID', value: uniqueId },
        { label: '开始时间', value: startTime },
        { label: '创建时间', value: createdAt },
      ]
    }
  },
  methods: {
    async getDialogDetail() {
      try {
        if (!this.id) return
        const r = await aiFriendManageApi.getAiDialogDetail({ id: this.id, ...this.params })
        this.chatSession = r.data.chatSession
        this.chatMessages = r.data.list ? r.data.list.toReversed() : []
        this.total = r.data.total
        this.contentToBottom()
      } catch (error) {
        console.error('get ai dialog detail error:', error);
      }
    },
    async contentToBottom() {
      await this.$nextTick()
      this.$refs.content.scrollTop = this.$refs.content.scrollHeight - this.$refs.content.offsetHeight
    },
    close() {
      this.visible = false
    },
    open(row) {
      if (row) this.id = row.id
      this.visible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-detail {
  text-align: left;

  /deep/ .el-dialog {
    margin-bottom: 0;
  }

  &__main {
    display: flex;
    height: 80vh;

    .dialog-info {
      width: 350px;
      border-right: #0002 1px solid;

      .info-row {
        margin: 20px 0;

        .label {
          display: inline-block;
          width: 80px;
        }
      }
    }

    .dialogs {
      flex: 1;
      display: flex;
      flex-direction: column;

      .content {
        flex: 1;
        overflow: auto;
        padding: 16px;

        .chat-row {
          $chat-bg-color: rgb(175, 220, 132);
          display: flex;

          &.isUserMsg {
            justify-content: flex-end;

            .chat-item {
              &::after {
                border-left: 10px solid $chat-bg-color;
                border-right: none;
                right: -10px;
                left: unset;
              }
            }
          }

          .chat-item {
            position: relative;
            background-color: $chat-bg-color;
            padding: 10px;
            display: flex;
            flex-direction: column;
            margin: 10px 0;
            max-width: 80%;
            border-radius: 6px;

            &::after {
              content: '';
              position: absolute;
              display: block;
              left: -10px;
              bottom: 12px;
              border-right: 10px solid $chat-bg-color;
              border-top: 8px solid white;
              border-bottom: 5px solid white;
            }

            .time {
              color: rgb(79, 108, 66);
            }
          }
        }
      }

      .pagination {
        z-index: 100;
        bottom: 0;
        width: 100%;
        background-color: #fff9;
        backdrop-filter: blur(5px);
        overflow: hidden;

        .el-pagination {
          margin-top: 0;
        }
      }
    }
  }

}
</style>